module.exports = __webpack_public_path__ + "img/nairobi3.c8635cd7.jpg";